
// デフォルトでオプションは非表示にしているので、オプションへのリンク付与、表示、必要であれば非活性化する。
function setCombinedLink(pId = '', optionId = '', remove_disable = false) {
    try {
      const aElement = document.getElementById(`${optionId}[optionvalue]`);
      const divElement = document.getElementById(`${optionId}[blockswatch]`);
      if (aElement && divElement) {
        if (remove_disable == true) {
          aElement.href = `${pId}`;
          divElement.classList.remove('block-swatch--disabled');
        } else {
          divElement.classList.add('block-swatch--disabled');
        }
        divElement.removeAttribute('hidden');
      } else {
        console.warn(`ID ${optionId}[optionvalue] または ${optionId}[blockswatch] の要素が見つかりません。`);
      }
    } catch (error) {
      console.error('要素の設定中にエラーが発生しました:', error);
    }
  }
  
const idBooleanMap = {};
function updateMap(id="", value="", pId="")
{
  if (idBooleanMap[id] === undefined) 
  {
    idBooleanMap[id] = [value, pId];
  } 
  else if (idBooleanMap[id][0] === false)
  {
    idBooleanMap[id] = [value, pId];
  }
}

function getCurrentProduct(option_arraysdict, request_path = "") {
    var currentOption = '';
    for (const options of option_arraysdict) {
      if (options.handle == request_path) {
        currentOption = options;
        break ;
      }
    }
    if (!currentOption || !currentOption.option_ids)
      return ;
    if (currentOption.option_ids && currentOption.option_ids.length == 1) {
        // オプションが1商品につき一個の場合は、そのままリダイレクトを表示
        for (const options of option_arraysdict) {
            setCombinedLink(options.handle, options.option_ids[0], true);
        }
    } else if (currentOption.option_ids.length == 2) {
        //オプションが1商品につき2個の場合(例：ある商品A：[模様A, 色A],ある商品B：[模様A, 色B],ある商品C：[模様B, 色B])
        //現在開いているページが商品Cページの時は、模様Bが選択されているのでオプションとして色Aはない。そのためdisableのまま
        for (const options of option_arraysdict) {
          if (String(options.option_ids[0]) != String(currentOption.option_ids[0])) {
            updateMap(options.option_ids[0], true, options.handle);
            updateMap(options.option_ids[1], false, options.handle);
          } else {
            updateMap(options.option_ids[0], true, options.handle);
            updateMap(options.option_ids[1], true, options.handle);
          }
      }
      for (let [key, value] of Object.entries(idBooleanMap)) {
        setCombinedLink(value[1], key, value[0]);
      };
    }
}

// combined listingとは別に現在開いている商品にぶら下がっているvariant商品は、リダイレクトではなくデフォルトのまま表示
function validVariants(options_array = []) {
    let divTag;
    for (const option of options_array) {
      divTag = document.getElementById(`${option}[blockswatch]`);
      if (!divTag){
        continue;
      }
      divTag.classList.remove('block-swatch--disabled');
      divTag.removeAttribute('hidden');
      const inputsTag = divTag.querySelectorAll('input');
      if (inputsTag.length <= 0){
        continue;
      }
      inputsTag.forEach(inputTag => {
        inputTag.removeAttribute('disabled');
      });
    }
}

function create_cross_product(items = [], option_ids_array = [], shop_domain = "", request_path = "") {
    const option_ids_comb_array = [];
    let removeIndex;
    let data_body;
    const comb_data = {
      shop_domain: shop_domain,
      target_items: items,
      location_href: window.location.href
    };
    
    $.ajax({
      type: 'POST',
      url: '/a/comb-group_' + window.deployConfig.combined_app_stage + '01/app/check_combgroup',
      contentType: 'application/json',
      data: JSON.stringify(comb_data),
    }).done(function(data){
      data_body = JSON.parse(data.body) || [];
      console.log(`body: ${data_body}`)
      
      // combined listingとは別に現在開いている商品にぶら下がっているvariant商品のリストを取得
      for (const one_product of data_body.description) {
        const combindChildrens = one_product.combined_listings || [];
        for (const combindChildren of combindChildrens) {
          option_ids_comb_array.push([combindChildren.handle, combindChildren.option_ids]);
          for (const option_id of combindChildren.option_ids) {
            removeIndex = option_ids_array.indexOf(option_id);
            if (removeIndex !== -1) {
              option_ids_array.splice(removeIndex, 1);
            }
          }
        }
      }
      if (Array.isArray(data_body.description) && data_body.description.length > 0) {
        getCurrentProduct(data_body.description[0].combined_listings, request_path);
        validVariants(option_ids_array);
      }
    }).fail(function(XMLHttpRequest, status, e) {
      console.log("AJAX request failed.");
      console.error("Status:", status);
      console.error("Error:", e);
    });
}